export default "__VITE_ASSET__PU8P2toE__"